/**
 * HubSpendComponent created by karora on 25/03/19.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { DailyBurn } from '../types/daily-burn';
import { HubSpendInfo } from '../types/hub-spend';
import { QuestionAnswer } from '../types/question-answer';

enum graphOptions {
  thisWeek = 1,
  thisMonth,
  thisYear,
  last14Days,
  last90Days,
  last365Days,
}

@Component({
  selector: 'hub-spend',
  templateUrl: './hub-spend.component.html',
  styleUrls: ['./hub-spend.component.css'],
  providers: [HubService],
})

export class HubSpendComponent implements OnInit {
  hubID: number;
  spend: HubSpendInfo;
  answers: QuestionAnswer[];
  errorMessage: string;
  dailyBurns: DailyBurn[] = [];
  numberOfDays: number = 14;
  burnTimePerPeriod: number = 0;
  spendPerPeriod: number = 0;
  unitPerPeriod: number = 0;
  agaCostPerPeriod: number = 0;


  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getHubSpend(+params['hubid']))
    ).subscribe(
      (spendInfo: HubSpendInfo) => this.gotSpend(spendInfo),
      err => HubService.LogRefreshError(err)
    );
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getSpendAnswers(+params['hubid']))
    ).subscribe(
      (answers: QuestionAnswer[]) => this.gotAnswers(answers),
      err => HubService.LogRefreshError(err)
    );
  }

  changeTimeFrame(newTimeFrame: number){
    let currentDate = new Date()
    switch(newTimeFrame) {
      case graphOptions.thisWeek:
        this.numberOfDays = currentDate.getDay();
        break;
      case graphOptions.thisMonth:
        this.numberOfDays = currentDate.getUTCDate();
        break;
      case graphOptions.thisYear:
        this.numberOfDays = (Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(currentDate.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
        break;
      case graphOptions.last14Days:
          this.numberOfDays = 14;
        break;
      case graphOptions.last90Days:
          this.numberOfDays = 90;
        break;
      case graphOptions.last365Days:
          this.numberOfDays = 365;
        break;
      default:  this.numberOfDays = newTimeFrame;
    }

    this.parseDailyBurns()
    this.spendPerPeriodCalculator()
  }

  spendPerPeriodCalculator(){
    this.burnTimePerPeriod = 0;
    this.spendPerPeriod = 0;
    for(let i = 0; i< this.numberOfDays; i++){
      this.spendPerPeriod  += this.spend.days[i];
    }

    this.agaCostPerPeriod = (this.spend.dailyaga * this.numberOfDays)
    this.unitPerPeriod = Math.round(((this.spendPerPeriod - this.agaCostPerPeriod) / Number(this.spend.centsperunit)) * 100) / 100
    this.burnTimePerPeriod = Math.round(( this.unitPerPeriod/ Number(this.spend.unitsperminute)) * 100) / 100
  }

  parseDailyBurns(){
    this.dailyBurns = []
    for(let i = 0; i< this.numberOfDays; i++){
      let currentDate = new Date()
      currentDate.setUTCHours(1,0,0,0)
      currentDate.setDate(currentDate.getDate()-i);
      let dailyBurntime = (this.spend.days[i]-this.spend.dailyaga) / (Number(this.spend.centsperunit) * Number(this.spend.unitsperminute))
      this.dailyBurns.push({date: currentDate, burntime: Math.round(dailyBurntime), spend: this.spend.days[i]})
    }
  }

  gotSpend(spendInfo: HubSpendInfo) {
    this.spend = spendInfo;
    this.parseDailyBurns()
    this.spendPerPeriodCalculator()
  }

  gotAnswers(answers: QuestionAnswer[]) {
    this.answers = answers;
  }

}
